import { ComponentDataDestService } from '../component-data-dest.service';
import { ComponentDataSourceService } from '../../component-data-source/component-data-source.service';
import { catchError, map, switchMap, of } from 'rxjs';
import { environment } from '../../../environment/environment';

export function add_template(
  componentDataDestService: ComponentDataDestService,
  componentDataSourceService: ComponentDataSourceService,
  data: any
) {
  const templatePayload = {
    name: data.name,
    description: data.description || '',
    visibility: data.visibility || 'private',
    template_data: data.template_data || {}
  };

  const request$ = componentDataDestService.http
    .post<{ template_id?: number; message?: string }>(
      `${environment.apiUrl}/duna_templates`,
      templatePayload
    )
    .pipe(
      catchError((error) => {
        console.error('[add_template] Error:', error);
        throw error;
      }),
      switchMap((response) =>
        componentDataSourceService.updateStoreData(of(response), 'templates').pipe(
          map(() => response)
        )
      )
    );

  return request$;
}
